import {useCallback, useEffect, useRef, useState} from 'react';

const useRecaptcha = (props) => {

  const [captchaToken, setCaptchaToken] = useState('');
  const [verification, setVerification] = useState(false);
  const recaptchaRef = useRef();
  let url = process.env.REACT_APP_MODE !== null && process.env.REACT_APP_MODE !== undefined && process.env.REACT_APP_MODE.includes('dev') ? 'http://localhost:8080/edge' : '/edge';

  const handleRecaptcha = useCallback((token) => {
    //setCaptchaToken(token || '');
    console.log('validating v2 recaptcha');
    fetch(url + '/vero/validate/recaptcha' , {
      method: "GET",
      mode: "cors",
      headers: new Headers({
        "Content-Type": "application/json",
        "Authorization": 'By-Pass-Auth-Create-Prospect',
        "captchaRequest": token
      }),
    })
      .then(response => {
        if (!response.ok) {
          console.log("verification failed");

        } else {
          console.log("verification passed",response)
          setVerification(true);
         // console.log("props",props);
          props.handleChangeValue("isRecaptchaV2Verified", true);
        }
      })
      .catch(error => {
        console.log('Error:', error);
        window.location.href = `/error-occurred`;
      });
  }, []);

  useEffect(() => {
    const refreshCaptcha = () => {
      if (recaptchaRef.current && captchaToken) {
        recaptchaRef.current.reset();
        setCaptchaToken('');
      }
    };

    let tokenRefreshTimeout = null;

    if (captchaToken) {
      tokenRefreshTimeout = setTimeout(refreshCaptcha, 110000); // 110 seconds
    }

    return () => {
      if (tokenRefreshTimeout) {
        clearTimeout(tokenRefreshTimeout);
      }
    };
  }, [captchaToken]);

  return { captchaToken, setCaptchaToken, recaptchaRef, handleRecaptcha };
};

export default useRecaptcha;
